import { render } from "./CaiGouShenPi.vue?vue&type=template&id=3481b3ed"
import script from "./CaiGouShenPi.vue?vue&type=script&lang=js"
export * from "./CaiGouShenPi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__